import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import jwt from 'jwt-simple';

import Analytics from 'APP_ROOT/services/analytics';
import BuildSettings from '../../buildSettings';
import Events from '../../common/events';
import lsUtil from '../../common/lsUtil';
import RavenUtil from '../../common/ravenUtil';
import CognitoUtil from '../../aws/cognito/cognitoUtil.js';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { determineFeatures } from 'APP_ROOT/components/common/views';
import Permissions from '../../../data/permissions';

import MobileBillingPage from './billing/mobileBillingPage';
import MobileUsersPage from './users/mobileUsersPage';
import NotFoundPage from '../../pages/notFoundPage';


import { strings } from '../../../localization'

window.loadWithMobileContext = function (context) {

    try {
        // console.log('MOBILE CONTEXT: ', context);
        document.dispatchEvent(new CustomEvent('mobilecontextloaded', { detail: { context: context } }));
    } catch (e) {
        console.error(e);
        return null;
    }
}

export default class MobileSessionManager extends Component {

    constructor(props) {

        super(props);

        this.state = {
            accountDetails: null,
            ravens: null,
            features: BuildSettings.applyBuildFeatures({})
        }
    }

    componentDidMount() {
        Analytics.pageView();
        if (window.location.href.contains('localhost')) {
            this.devLogin();
        } else {
            document.addEventListener('mobilecontextloaded', this.onMobileContextLoaded);
        }
        // console.log("mobile component did mount, showing loading");
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_loading) } }));
    }

    onMobileContextLoaded = (e) => {

        this.mobileContext = e.detail.context;

        var payload = jwt.decode(this.mobileContext.idToken, "", true);

        this.setState({
            user: { 
                stage: payload["custom:linked_raven_stage"]
            }
        }, () => {
            // Attempt to log in after setting state in stage
            CognitoUtil.mobileSpecialLogin(
                this.mobileContext.idToken,
                () => this.onLoginSuccess(this.mobileContext.ravenUuid),
                this.onLoginFail
            );
        });
    }

    devLogin() {

        this.getUserData(() => {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        });
    }

    getUserData = (onGetUserDataComplete) => {

        this.onGetUserDataComplete = onGetUserDataComplete;
        // console.log("get user data show loading page");
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_loading) } }));
        CognitoUtil.refreshLogin(
            () => {
                this.onLoginSuccess();
            },
            (e) => {
                console.error(e);
            }
        );
    }

    onLoginSuccess = (ravenUuid = null) => {

        // console.log('login success!');
        if (ravenUuid) lsUtil.setItem('raven.selectedRavenUuid', ravenUuid);

        this.finishLogin();
    }

    finishLogin() {

        // console.log("finishLogin");

        if (BuildSettings.billingEnabled) {
            // console.log("finish login show loading page");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_loading), 'override': true } }));
            LambdaUtil.getAccountDetails(this.state.user.stage, Permissions.ACCOUNT_PERMISSIONS_LIST, this.onAccountDetailsSuccess, this.onAccountDetailsFail);
        } else {
            // console.log("finish login show loading page2");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.app_loading), 'override': true } }));
            LambdaUtil.getRavens(this.state.user.stage, this.onGetRavensSuccess, this.onGetRavensError);
        }
    }

    onLoginFail = () => {

        console.error('login failed!');
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onAccountDetailsSuccess = e => {

        try {
            var payload = null;
            if (e.Payload)
                payload = JSON.parse(e.Payload);

            // console.log("account details success");

            var accountDetails = payload.payload;

            if (!accountDetails) {
                accountDetails = {};
            }

            // payload.payload can be undefined for invited users
            if (payload.status && payload.status !== "ERROR" && accountDetails.subscriptions) { //checks if subscriptions exists and is of length > 0 ([] == false)

                // var servicePlanListUrl = '/serviceplans/plans.json';
                // axios({
                //     method: 'get',
                //     url: servicePlanListUrl
                // }).then((response) => {
                //     accountDetails.servicePlans = response.data


                // }).catch(function (response) {
                //     console.error('error', response);
                // });

                //DEBUGGING
                if (BuildSettings.isDev()) {
                    //remove all service plans
                    // accountDetails.subscriptions = [];

                    //duplicate sub with faked dupliated raven as target
                    // accountDetails.subscriptions[1] = JSON.parse(JSON.stringify(accountDetails.subscriptions[0]));
                    // accountDetails.subscriptions[1].raven = { ravenUuid: "222" };

                    //DEBUG For testing when trial is ending.
                    // accountDetails.subscriptions[0].planSelectionRequired = true;
                    // accountDetails.subscriptions[0].planCode = "freetrial";
                    // accountDetails.subscriptions[1].planCode = "freetrial";

                    //DEBUG for testing with no service plan
                    // accountDetails.subscriptions.splice(0, 1); 

                    //DEBUG other, force basic plan
                    // accountDetails.subscriptions[0].planCode = "basic";
                    // accountDetails.subscriptions[0].amountInCents = "800";
                    // accountDetails.subscriptions[0].amountInCents = "0";
                    // accountDetails.subscriptions[0].streamingUsedPercent = 50;
                }

                accountDetails.subscriptions.forEach(sub => {

                    if (!sub || !sub.planCode || !sub.subscriptionUuid) return;

                    //add flag for 'no streaming limit' plans for easier reading later
                    if (sub.planCode.indexOf('freetrial') > -1 ||
                        sub.planCode.indexOf('free_trial') > -1 ||
                        sub.planCode.indexOf('journalist') > -1 ||
                        sub.planCode.indexOf('affirm') > -1 ||
                        sub.planCode.indexOf('employee') > -1) {

                        sub.noLimitPlan = true
                    } else {
                        sub.noLimitPlan = false
                    }
                    //flag plans that will be replaced with pending plan at end of cycle
                    accountDetails.subscriptions.forEach(sub2 => {
                        if (sub2.state === 'pending' && sub.subsciptionUuid === sub2.subsciptionUuid) sub.pendingSub = sub2; //make pendingSub ref
                    })
                })

                // console.log("Setting account details state");

                this.setState({
                    accountDetails: accountDetails,
                }, () => {
                    //also get service plans
                    // console.log("Listing service plans");
                    LambdaUtil.listServicePlans(this.state.user.stage, this.onListServicePlansSuccess, this.onListServicePlansFail);
                });
            } else {
                // From sessionManager updates: no recurly account. Still get list of ravens, this is
                // an old code path that is now being used again for
                // non-legacy channels

                // From sessionManager updates: Fixes RAV-2010 (onGetRavensSuccess crashes at accountDetails.subscriptions.find())
                accountDetails.subscriptions = [];

                this.setState({
                    accountDetails: accountDetails,
                }, () => {
                    LambdaUtil.getRavens(this.state.user.stage, this.onGetRavensSuccess, this.onGetRavensError);
                });
            }
        } catch (e) {
            this.onAccountDetailsFail(e);
        }
    }

    onAccountDetailsFail = e => {
        console.error(e);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onListServicePlansSuccess = (response) => {

        // console.log("ListServicePlansSuccess");
        var servicePlans = null
        try {
            if (response.Payload)
                servicePlans = JSON.parse(response.Payload).listServicePlans;

            this.setState({
                availableServicePlans: servicePlans.plans
            })

            // console.log("Get Ravens from Service Plans");

            LambdaUtil.getRavens(this.state.user.stage, this.onGetRavensSuccess, this.onGetRavensError);
        } catch (e) {
            this.onListServicePlansFail(e);
        }
    }

    onListServicePlansFail = (error) => {

        console.error(error);

        //errorReporting.error(error); // errorReporting has not been added to mobileSessionManager, presumably because the mobile apps have reporting already
    }

    onGetRavensSuccess = (data) => {

        // console.log("GetRavensSuccess");

        try {
            var payload = JSON.parse(data.Payload);
            var ravens = payload.ravens ? payload.ravens.ravens : null;
            
            ravens = this.decorateRavensWithPermissions(ravens);

            var selectedRaven = null;
            if (ravens && (ravens.length === 1 || lsUtil.getItem('raven.selectedRavenUuid'))) selectedRaven = RavenUtil.getSelectedRaven(ravens);
            // console.log("Ravens: ", ravens, "\nSelectedRaven: ", selectedRaven);

            //DEBUG create fake duplicate raven
            // ravens[1] = JSON.parse(JSON.stringify(ravens[0]));
            // ravens[1].ravenUuid = "222"

            // console.log("Setting raven state");

            if(payload.status && payload.status === "ERROR")
            {
                // Error attempting to query Ravens
                console.log("Error querying Ravens", payload.message);
            }

            // pass in null for custom user flags as we don't have anything to report
            const features = determineFeatures(this.state.features, this.state.accountDetails, ravens, null);

            // console.log(data);
            this.setState({
                ravens: ravens,
                selectedRaven: selectedRaven,
                features,
            }, () => {
                if (this.onGetUserDataComplete) {
                    this.onGetUserDataCompleteCalled = true;
                    this.onGetUserDataComplete();
                }
            });

            // console.log("Setting raven state: Hiding loading page");

            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        } catch (e) {

            this.onGetRavensError(e);
        }
    }

    onGetRavensError = (error) => {
        // console.log("onGetRavensError");

        console.error(error);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    refreshAccountDetails() {

        LambdaUtil.getAccountDetails(this.state.user.stage, Permissions.ACCOUNT_PERMISSIONS_LIST, this.onAccountDetailsSuccess, this.onAccountDetailsFail);
    }

    decorateRavensWithPermissions(ravens) {
        if (!ravens || !ravens.length) {
            return ravens;
        }

        return ravens.map(raven => {
            const canEdit = raven.permissions && raven.permissions.includes("raven:WriteRavens");
            return {
                ...raven,
                canEdit: !!canEdit
            };
        });
    }

    render() {

        // console.log("Mobile Session Render", this.props, this.state);
        document.querySelector('html').classList.add('dark-theme');

        return (
            <div id="mobileSessionManager">
                <div id="mainContent">
                    <Switch>
                        <Route exact path="/:lang/mobile/users" render={props => (
                            <MobileUsersPage {...props} {...this.state} refreshAccountDetails={this.refreshAccountDetails} />
                        )} />
                        <Route exact path="/:lang/mobile/billing" render={props => (
                            <MobileBillingPage {...props} {...this.state} refreshAccountDetails={this.refreshAccountDetails} />
                        )} />
                        <Route render={props => {
                            return <NotFoundPage {...props} />
                        }} />
                    </Switch>
                </div>
            </div>
        )
    }
}
